// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.graphContainer{\n  width: 100%;\n  height: 300px;\n  margin: auto;\n}\n", ""]);
// Exports
module.exports = exports;
